import { render, staticRenderFns } from "./bigVotePh.vue?vue&type=template&id=948f8582&scoped=true"
import script from "./bigVotePh.vue?vue&type=script&lang=js"
export * from "./bigVotePh.vue?vue&type=script&lang=js"
import style0 from "./bigVotePh.vue?vue&type=style&index=0&id=948f8582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948f8582",
  null
  
)

export default component.exports